/** Preset date range values for the audit log filter. */
export const DATE_RANGE_VALUES = [
  "all",
  "1h",
  "24h",
  "7d",
  "30d",
  "90d",
] as const;

export type DateRangeValue = (typeof DATE_RANGE_VALUES)[number];

export const DATE_RANGE_OPTIONS: Array<{
  label: string;
  value: DateRangeValue;
}> = [
  { label: "All time", value: "all" },
  { label: "Last hour", value: "1h" },
  { label: "Last 24 hours", value: "24h" },
  { label: "Last 7 days", value: "7d" },
  { label: "Last 30 days", value: "30d" },
  { label: "Last 90 days", value: "90d" },
];

const DURATION_MS: Record<Exclude<DateRangeValue, "all">, number> = {
  "1h": 60 * 60 * 1000,
  "24h": 24 * 60 * 60 * 1000,
  "7d": 7 * 24 * 60 * 60 * 1000,
  "30d": 30 * 24 * 60 * 60 * 1000,
  "90d": 90 * 24 * 60 * 60 * 1000,
};

/**
 * Convert a preset date range value to an ISO 8601 start_time string.
 * Returns undefined for "all" (no time filter).
 */
export function dateRangeToStartTime(
  value: DateRangeValue
): string | undefined {
  if (value === "all") {
    return;
  }

  return new Date(Date.now() - DURATION_MS[value]).toISOString();
}
